/* Copyright (c) 2021-2025, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

// Standard mapping defined in https://www.w3.org/TR/gamepad/#remapping
export enum GamepadButtonName {
    A = 0,
    B = 1,
    X = 2,
    Y = 3,
    LeftBumper = 4,
    RightBumper = 5,
    LeftTrigger = 6,
    RightTrigger = 7,
    Back = 8,
    Start = 9,
    LeftStick = 10,
    RightStick = 11,
    DpadUp = 12,
    DpadDown = 13,
    DpadLeft = 14,
    DpadRight = 15,
    Center = 16 // e.g. XBox/PS button
}

export interface MonitorOptions {
    /**
     * Whether to repeatedly emit `pressed` state.
     */
    repeat?: boolean;
    customButtonIndex?: number;
}
